import { render, staticRenderFns } from "./DisplayMailBody.vue?vue&type=template&id=4088ef7f&"
import script from "./DisplayMailBody.vue?vue&type=script&lang=js&"
export * from "./DisplayMailBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports